const cardLabelList = [
  {
    Name: 'Kartu Kuning',
    PrimaryColor: '#FFA800',
    SecondaryColor: '#FFF9EE'
  },
  {
    Name: 'Kartu Merah',
    PrimaryColor: '#F40023',
    SecondaryColor: '#FFEBEB'
  }
]

export default cardLabelList